"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upperFirstLetter = void 0;
var upperFirstLetter = function (value) { return "".concat(value[0].toLocaleUpperCase()).concat(value.slice(1)); };
exports.upperFirstLetter = upperFirstLetter;
//# sourceMappingURL=upperFirstLetter.js.map